import React from 'react';
import ReactPlayer from 'react-player';

interface Props {
  url: string;
  elementId?: string;
  className?: string;
  playerStyle?: React.CSSProperties;
  width?: string;
  height?: string;
  controls?: boolean;
  playing?: boolean;
  loop?: boolean;
  muted?: boolean;
  onEnded?: () => void;
  elementKey?: React.Key;
}

const VideoPlayer: React.FC<Props> = ({
  url,
  className,
  playerStyle,
  onEnded,
  elementId = 'video_player',
  width = '90vh',
  height = 'auto',
  controls = true,
  playing = true,
  loop = true,
  muted = true,
  elementKey: key,
}) => (
  <div
    id={elementId}
    data-testid={elementId}
    key={key}
    className={className}>
    <ReactPlayer
      style={playerStyle}
      url={url}
      playing={playing}
      controls={controls}
      width={width}
      loop={loop}
      height={height}
      muted={muted}
      onEnded={onEnded}
    />
  </div>
);

export default VideoPlayer;
